import script from "./AppPaletteColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPaletteColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./AppPaletteColorPicker.vue?vue&type=style&index=0&id=5c2b752b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2b752b"]])

export default __exports__